module.exports = __webpack_public_path__ + "static/media/slider2023-02.a37f52fe.jpg";